
import { Icon, Link } from '@material-ui/core';
import DataTable from '../../../ShearCompo/DataTable/DataTable';
import { Select } from 'antd';
import toast from 'react-hot-toast';
import { ToastNotify } from '../../../ShearCompo/ToastNotify/ToastNotify';
import { Popconfirm } from 'antd';

const AssignGroups = () => {

    const assignAdminData = [
        {
            id: '#546651',
            name: 'Shahed Ador',
            userName: 'ador123',
            creationDate: '4:44AM 17 August, 2021',
        },
        {
            id: '#546652',
            name: 'Amimul Rahi',

            role: 'Admin',
        },
        {
            id: '#546653',
            name: 'Abu Hasan',
            userName: 'abu123',
            role: 'Editor',
            creationDate: '4:44AM 17 August, 2021',

        },
        {
            id: '#546654',
            name: 'Saifur Sakib',
            userName: 'sakib123',
            role: 'Editor',
            creationDate: '4:44AM 17 August, 2021',

        },
        {
            id: '#546655',
            name: 'MeHeDi HaSaN',
            userName: 'mhk123',
            creationDate: '4:44AM 17 August, 2021',

        },

    ]
    const tableHeading = ['Assign ID', 'User Name', 'Group Name', 'Assignment Date', 'Action']
    //  this is for antDesign  func. for select users
    const { Option } = Select;
    const children = [];
    for (let i = 10; i < 36; i++) {
        children.push(<Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>);
    }
    let handleChange = (value) => {
        console.log(`selected ${value}`);
    }
    
  // remove mapping warning
  let confirm = (e) => {
    console.log(e);
    if (e) {
        toast.success("Assignment is removed successfully!");
       
    } else {
        toast.error("Something went wrong, please try again!")
    }

}
    return (
        <div className="w-100 overflow-hidden">
            <div className="row mb-4">
                <h4>Assigns Groups</h4>
                <div className="col-lg-4">
                    <label className="form-label">Group</label>
                    <select className="form-select" aria-label="Default select example">
                        <option defaultValue="">Support Group</option>
                        <option defaultValue="">Ticket Group</option>
                        <option defaultValue="">Call Group</option>
                        <option defaultValue="">Sell Group</option>
                    </select>
                </div>
                <div className="col-lg-6">
                    <div className="mb-3">
                        <label  className="form-label">User</label>
                        <Select
                            size={"large"}

                            mode="multiple"
                            allowClear
                            style={{ width: '100%' }}
                            placeholder="Select User(s)"
                             onChange={handleChange}
                        >
                            {children}
                        </Select>
                    </div>
                </div>
                <div className="col-lg-2 mt-4 pt-1 ">
                     <button className="btn btn-success px-5" >Assign </button>
                    </div>
                {/*  */}
            </div>
            <div className="adminBtn d-flex justify-content-between">
                <div className="d-flex csvPdfParent">
                    <div className="d-flex align-items-center singleBtn MainLightGreen mx-0">
                        <Icon className="MainLightGreen">download</Icon>
                        <span>Download CSV</span>
                    </div>
                    <div className="d-flex align-items-center singleBtn MainLightGreen">
                        <Icon className="MainLightGreen">download</Icon>
                        <span>Download PDF</span>
                    </div>
                </div>

            </div>
            <div className="row">
                <DataTable tableHeading={tableHeading} tableBodyData={
                    assignAdminData && assignAdminData.map((tableData, index) =>
                        <tr key={index} className="text-center">
                            <th scope="row">{tableData.id}</th>
                            <td>{tableData.name}</td>
                            <td>{tableData.userName ? tableData.userName : <span className="text-white bg-danger rounded p-1"> Unassigned</span>} </td>

                            <td className=" rounded"> {tableData.creationDate ? tableData.creationDate : <span className="text-white bg-danger rounded p-1"> Unassigned</span>} </td>

                            <td className="text-danger cursorPointer d-flex align-items-center justify-content-center">
                                <i className="far fa-trash-alt"></i>&nbsp;&nbsp;
                                <span className="text-decoration-underline" > 
                                
                                <Popconfirm
                                        title="Are you sure to remove this mapping?"
                                        onConfirm={() => { confirm(tableData.id) }}

                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <Link className="text-danger">Remove mapping</Link>
                                    </Popconfirm>
                                
                                </span>
                            </td>
                        </tr>
                    )
                } />
            </div>
            <ToastNotify />

        </div>
    );
};

export default AssignGroups;